import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Filters',

  mixins: [ proxy({ type: 'object' }) ],

  computed: {
    /**
     * Значения полей фильтра в меню кнопки фильтра по умолчанию для кнопки сброса.
     *
     * @returns {Object<string, undefined>} Пустое значение по имени поля.
     */
    defaultFilter() {
      return {
        signMethod: undefined,
        OwnerId: undefined,
        RequisiteId: undefined,
        CompanyId: undefined
      }
    }
  },

  render
}
